import {
  useTheme,
  useMediaQuery,
  Box,
  Typography,
  Button,
} from "@mui/material";
import {
  NavigationInstructionsRoot,
  NavigationInstructionsItem,
} from "./NavigationInstructions.styles";
import RotateDesktopImg from "../../assets/instructions/rotate-desktop_img.svg";
import RotateDesktopIcon from "../../assets/instructions/rotate-desktop_icon.png";
import ZoomDesktopImg from "../../assets/instructions/zoom-desktop_img.svg";
import ZoomDesktopIcon from "../../assets/instructions/zoom-desktop_icon.png";
import CameraPanDesktopImg from "../../assets/instructions/camera-pan-desktop_img.svg";
import CameraPanDesktopIcon from "../../assets/instructions/camera-pan-desktop_icon.png";
import RotateMobileImg from "../../assets/instructions/rotate-mobile_img.svg";
import ZoomMobileImg from "../../assets/instructions/zoom-mobile_img.svg";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { BackgroundMedia } from "../BackgroundMedia";
import { useRouteParams } from "../../context/RouteParamsContext";

export const NavigationInstructions = ({
  show,
  onHandleClose,
  videoInitialized,
  arcwareApplication,
}) => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const { projectName } = useRouteParams();

  const iconsDesktop = [
    {
      alt: "Rotate",
      imgSrc: RotateDesktopImg,
      iconSrc: RotateDesktopIcon,
      title: "Camera 360 rotation",
      descriptionMouse: "Left click (Mouse)",
      descriptionTrackpad: "Swipe (Trackpad)",
    },
    {
      alt: "Zoom",
      imgSrc: ZoomDesktopImg,
      iconSrc: ZoomDesktopIcon,
      title: "Camera zoom",
      descriptionMouse: "Wheel scroll (Mouse)",
      descriptionTrackpad: "Pinch (Trackpad)",
    },
    {
      alt: "Camera Pan",
      imgSrc: CameraPanDesktopImg,
      iconSrc: CameraPanDesktopIcon,
      title: "Camera pan",
      descriptionMouse: "Middle button click + move (Mouse)",
      descriptionTrackpad: "",
    },
  ];

  const iconsMobile = [
    {
      alt: "Rotate",
      imgSrc: RotateMobileImg,
      iconSrc: RotateMobileImg,
      title: "Camera 360 rotation",
      descriptionMouse: "",
      descriptionTrackpad: "Swipe to rotate",
    },
    {
      alt: "Zoom",
      imgSrc: ZoomMobileImg,
      iconSrc: ZoomMobileImg,
      title: "Camera zoom",
      descriptionMouse: "",
      descriptionTrackpad: "Pinch to zoom",
    },
  ];

  const isTouchDevice = () => {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  };

  const instructions = isTouchDevice() ? iconsMobile : iconsDesktop;

  return (
    <NavigationInstructionsRoot>
      <BackgroundMedia />
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 0) -10%, rgba(255, 255, 255, 1) 70%)",
        }}
      />
      <Box
        className="instructions__content"
        sx={{
          width: "100%",
          flexGrow: 1,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "'NewYork', 'Raleway','Helvetica','Arial',sans-serif",
          color: "#071A3D", // to be remove
        }}
      >
        <Typography
          className="instructions__title"
          variant="h1"
          sx={{
            fontFamily:
              "'NewYork', 'Raleway', 'Helvetica', 'Arial', sans-serif",
            textAlign: "center",
            position: "relative",
            "@media only screen and (min-width: 1025px) and (max-width: 1200px)":
              {
                fontSize: "16rem",
              },
            [theme.breakpoints.down("md")]: {
              "@media (orientation: landscape)": {
                fontSize: "8rem",
              },
            },
          }}
        >
          <Box
            sx={{
              fontSize: { xs: "5rem", sm: "9rem", lg: "11rem" },
            }}
          >
            3D Configurator
          </Box>
          <Box
            sx={{
              marginLeft: 0,
              textTransform: "uppercase",
              fontSize: { xs: "7rem", sm: "11rem", lg: "13rem" },
            }}
          >
            <b>{projectName ? projectName : "Showcase"}</b>
          </Box>
        </Typography>
        <Box
          sx={{
            // background: "#fa0",
            background: "#071A3D",
            // color: "#000",
            color: "#071A3D",
            padding: "0 3rem",
            display: "flex",
            justifyContent: { xs: "center", md: "flex-start" },
            alignItems: "center",
            zIndex: 99,
            borderRadius: "4px",
            marginTop: 10,
          }}
        >
          <Button
            sx={{
              // color: "#000",
              color: "#fff",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "1rem",
              fontFamily: "'NewYork', 'Raleway','Helvetica','Arial',sans-serif",
              fontSize: { xs: "1.75rem", lg: "2.25rem" },
              padding: { xs: "1.5rem", xl: "1.5rem 2.5rem" },
              transition: "all 0.3s ease",
              pointerEvents: !videoInitialized ? "none" : "all",
              cursor: !videoInitialized ? "default" : "pointer",
              "& svg": {
                transition: "all 0.3s ease",
              },
            }}
            onClick={() => {
              if (!videoInitialized) return;
              onHandleClose(false, "click");
              if (projectName) {
                let model = "";
                if (projectName === "airbus") model = "av";
                if (projectName === "electra") model = "ev";
                arcwareApplication.emitUIInteraction({ cv: model });
              }
            }}
          >
            {!videoInitialized ? (
              <>
                Loading
                <Box component="span" className="instructions__loading__dot">
                  .
                </Box>
                <Box component="span" className="instructions__loading__dot">
                  .
                </Box>
                <Box component="span" className="instructions__loading__dot">
                  .
                </Box>
              </>
            ) : (
              <>
                <DoubleArrowIcon
                  sx={{
                    padding: "3px 0 0",
                    fontSize: "3.5rem",
                  }}
                />
                <Box component="span">Start</Box>
              </>
            )}
          </Button>
        </Box>
      </Box>

      <Box
        className="instructions__details"
        sx={{
          // borderTop: "1px solid #fa0",
          borderTop: "1px solid #071A3D",
          width: "100%",
          boxSizing: "border-box",
          padding: 0,
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          flexGrow: { xs: 0.25, xl: 0.5 },
          [theme.breakpoints.up("sm")]: {
            display: "flex",
            flexDirection: "row",
            gap: 0,
          },
          [theme.breakpoints.down("md")]: {
            "@media (orientation: landscape)": {
              flexDirection: "column",
              width: "auto",
              height: "100%",
              borderTop: "none",
              marginTop: 0,
            },
          },
          [theme.breakpoints.down("sm")]: {
            marginTop: "2rem",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {instructions.map((item, index) => (
          <NavigationInstructionsItem key={index}>
            <Box
              component="img"
              src={item.iconSrc}
              alt={item.alt}
              sx={{
                width: {
                  xs: "6rem",
                  sm: "4rem",
                  md: "6rem",
                  lg: "4rem",
                  xl: "4rem",
                },
                height: "auto",
                filter: "brightness(0)",
              }}
            />
            <Box
              sx={{
                textAlign: "left",
                fontFamily:
                  "'NewYork', 'Raleway','Helvetica','Arial',sans-serif",
                fontWeight: 300,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontFamily: '"Raleway", "Helvetica", "Arial", sans-serif',
                  fontSize: "1.6rem",
                  fontWeight: 600,
                  lineHeight: 1.1,
                  marginBottom: "0.5rem",
                }}
              >
                {item.title}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap:
                    item.descriptionMouse && item.descriptionTrackpad && "1rem",
                  alignItems: "center",
                }}
              >
                <Box
                  component="span"
                  sx={{
                    fontFamily: '"Raleway", "Helvetica", "Arial", sans-serif',
                    fontSize: "1.3rem",
                  }}
                >
                  {item.descriptionMouse}
                </Box>
                {item.descriptionMouse && item.descriptionTrackpad && (
                  <Box
                    component="span"
                    sx={{
                      fontFamily: '"Raleway", "Helvetica", "Arial", sans-serif',
                      fontSize: "1.3rem",
                    }}
                  >
                    |
                  </Box>
                )}
                <Box
                  component="span"
                  sx={{
                    fontFamily: '"Raleway", "Helvetica", "Arial", sans-serif',
                    fontSize: "1.3rem",
                    [theme.breakpoints.down("md")]: {
                      "@media (orientation: landscape)": {
                        fontSize: "1.2rem",
                      },
                    },
                    [theme.breakpoints.down("sm")]: {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  {item.descriptionTrackpad}
                </Box>
              </Box>
            </Box>
          </NavigationInstructionsItem>
        ))}
      </Box>
    </NavigationInstructionsRoot>
  );
};
